import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineBagDollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8 14.825c3.369 0 5.775-1.3 5.775-4.193 0-3.146-1.444-5.242-4.331-6.815l1.135-1.594a.74.74 0 0 0 .01-.694.67.67 0 0 0-.23-.257.6.6 0 0 0-.319-.097H5.96a.6.6 0 0 0-.319.097.67.67 0 0 0-.23.257.74.74 0 0 0 .01.694l1.135 1.604c-2.887 1.584-4.331 3.68-4.331 6.826 0 2.872 2.406 4.172 5.775 4.172"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M9.452 7.796a1.14 1.14 0 0 0-1.073-.758h-.88a1.015 1.015 0 0 0-.217 2.007l1.34.293a1.138 1.138 0 0 1-.243 2.25h-.758c-.496 0-.917-.317-1.073-.759M8 7.038V5.9M8 12.725v-1.137"
    />
  </svg>
);
export default SvgStreamlineBagDollar;
